import { action } from 'typesafe-actions';

import { LayoutTypes } from './types';

// Drawer
export const setLayoutVisible = (payload: { visible: boolean }) =>
  action(LayoutTypes.SET_LAYOUT_VISIBLE, payload);
